/*
 * Calendar helper: builds a universal .ics event for Advit's party and
 * triggers a one-tap download that opens in the phone's calendar app.
 *
 * Event: 24 Oct 2026, 17:00-20:00 IST (= 11:30-14:30 UTC) at Cottage 837.
 * Using UTC (Z) times keeps it unambiguous; IST guests see 5:00-8:00 PM.
 */

const ICS_LINES = [
  "BEGIN:VCALENDAR",
  "VERSION:2.0",
  "PRODID:-//Advit Excavator Dash//Birthday Invite//EN",
  "CALSCALE:GREGORIAN",
  "METHOD:PUBLISH",
  "BEGIN:VEVENT",
  "UID:advit-8th-birthday-20261024@excavator-dash",
  "DTSTAMP:20261020T000000Z",
  "DTSTART:20261024T113000Z",
  "DTEND:20261024T143000Z",
  "SUMMARY:Advit's 8th Birthday - Excavator Dash Party",
  "DESCRIPTION:Advit turns 8! A construction-crew birthday bash. Bring your hard hat! All roads lead to Cottage 837. 17:00-20:00 Hrs IST.",
  "LOCATION:Cottage 837",
  "STATUS:CONFIRMED",
  "BEGIN:VALARM",
  "TRIGGER:-PT1H",
  "ACTION:DISPLAY",
  "DESCRIPTION:Advit's birthday party starts soon!",
  "END:VALARM",
  "END:VEVENT",
  "END:VCALENDAR",
];

export function downloadPartyIcs() {
  const content = ICS_LINES.join("\r\n");
  const blob = new Blob([content], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "advit-birthday-oct24.ics";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

// Google Calendar fallback link (opens pre-filled event in a new tab)
export function googleCalendarUrl() {
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: "Advit's 8th Birthday - Excavator Dash Party",
    dates: "20261024T113000Z/20261024T143000Z",
    details: "Advit turns 8! A construction-crew birthday bash. Bring your hard hat! 17:00-20:00 Hrs IST.",
    location: "Cottage 837",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
